"use client";

import { useId } from "react";
import {
  bodyClass,
  headClass,
  inputClass,
  labelClass,
  messageBodyClass,
  messageClass,
  messageHeadClass,
  rowClass,
  submitButtonClass,
  submitClass,
} from "./authFormClasses";
import { fieldValue, useAuthForm } from "./useAuthForm";

/**
 * The port of fragments/auth/forgot-password-form.php and
 * forgot-password-form.js.
 *
 * On WordPress this posted to poppy_ajax_forgot_password, which asked the DAS
 * app's API to send a reset link and always answered that one had been sent if
 * the account existed, so the form never says whether an email is registered.
 * Here it goes through submitForm("forgot-password").
 *
 * The theme's footer link back to sign-in was commented out, so there is none.
 */
export default function ForgotPasswordForm() {
  const id = useId();
  const { message, success, onSubmit, stateAttributes } = useAuthForm(
    "forgot-password",
    (form) => ({
      email: fieldValue(form, "email"),
    }),
  );

  return (
    <form
      action=""
      className="group/form data-[loading=true]:pointer-events-none data-[loading=true]:opacity-50 js-forgot-password-form"
      id={`reset-assword-form-${id}`}
      onSubmit={onSubmit}
      {...stateAttributes}
    >
      <div className={headClass}>
        Please enter you email below to reset your password.
      </div>

      <div className={messageClass}>
        <h3 className={`${messageHeadClass} js-form-message-head`}>
          {message?.header || ""}
        </h3>

        <p className={`${messageBodyClass} js-form-message-body`}>
          {message?.body || ""}
        </p>
      </div>

      {/* On success the form goes and only the message stays. */}
      {!success && (
        <>
          <div className={`${bodyClass} js-form-body`}>
            <div className={rowClass}>
              <div>
                <label
                  htmlFor="forgot-password-form-email"
                  className={labelClass}
                >
                  Email
                </label>

                <input
                  type="email"
                  id="forgot-password-form-email"
                  name="email"
                  className={inputClass}
                  placeholder="Enter your email address"
                  autoComplete="email"
                  required
                />
              </div>
            </div>
          </div>

          {/*
           * The theme also faded this button while sending, but its rule was
           * written for .forgot-password__submit, which nothing carried, so it
           * only ever faded with the form.
           */}
          <div className={`${submitClass} js-form-submit`}>
            <button type="submit" className={submitButtonClass}>
              Reset
            </button>
          </div>
        </>
      )}
    </form>
  );
}
